import { render, staticRenderFns } from "./CheckingSystem.vue?vue&type=template&id=12b8dc5c&scoped=true"
import script from "./CheckingSystem.vue?vue&type=script&lang=js"
export * from "./CheckingSystem.vue?vue&type=script&lang=js"
import style0 from "./CheckingSystem.vue?vue&type=style&index=0&id=12b8dc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8dc5c",
  null
  
)

export default component.exports